// function for setting cell color based on percentage //
import React from "react"
import tinycolor from 'tinycolor2'

const QBAdj = ({ adj }) => {

    const neg_color = '#ffabc0'
    const zero_color = '#ffffff'
    const pos_text = '#65e0b7'

    if (adj <= 0) {
        return (
            <div style={{
                    color : tinycolor.mix(zero_color, neg_color, Math.abs(adj) * 5),
                    fontSize : '.7rem',
            }}>
                {adj}
            </div>
        )
    } else {
        return (
            <div style={{
                    color : tinycolor.mix(zero_color, pos_text, Math.abs(adj) * 5),
                    fontSize : '.7rem',
            }}>
                {adj}
            </div>
        )
    }
    
}

export default QBAdj